import { Antiphishing } from '@lib/hundredBricksAPI/authentication';

import { Token } from '../entities/Session';
import AuthenticationError, { Details } from '../errors/Authentication';
import errorMessages from '../errors/Authentication/errorMessages';

import GatewayAPI from './GatewayAPI';

class AuthenticationAPI extends GatewayAPI {
  async fetchAntiphishing(email) {
    try {
      const { data } = await this._client.get('/profile/antiphishing', { params: { email } });

      return new Antiphishing(data);
    } catch (error) {
      if (!error.response) {
        throw AuthenticationError.getNetworkError();
      }

      const { response } = error;
      const { code, metadata } = response.data;

      const authenticationError = new AuthenticationError(code);

      if (authenticationError.isTraderNotFound()) {
        authenticationError.details = new Details({
          message: errorMessages[code], ...metadata
        });
      }

      throw authenticationError;
    }
  }

  async refreshToken(token) {
    try {
      const { data } = await this
        ._client
        .post('/refreshSession', {}, { headers: { Authorization: `Bearer ${token}` } });

      // Expiration date returned by the API is ignored due possible users misconfigurations.
      // In some scenarios, users may have a wrong timezone configures on his/her device, in such
      // cases the application will expire the session immediately
      const expirationDate = new Date();

      expirationDate.setMinutes(expirationDate.getMinutes() + 5);

      return new Token(data.token, expirationDate);
    } catch (error) {
      return this._handleError(error);
    }
  }

  // Add ping to new API
  //
  // GET /sessions/ping
  //
  // {
  //   "serverTime": <Server time in ISO8601 in UTC>
  // }
  //
  // For now, we are querying the trader profile just to see if the token is still valid
  async ping() {
    try {
      await this._client.get('/traders/me');
    } catch (error) {
      this._handleError(error);
    }
  }

  async sendForgotPasswordCode(email) {
    try {
      const { data } = await this._legacyClient.post(
        '/forgotPassword/sendForgotPasswordCode',
        { email, channel: 'email' }
      );

      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async updateForgottenPassword(payload) {
    try {
      const { data } = await this._legacyClient.post('/forgotPassword', payload);

      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  _handleError(error) {
    if (!error.response) {
      throw AuthenticationError.getNetworkError();
    }

    const { response } = error;
    const { code } = response.data;

    throw new AuthenticationError(code);
  }
}

export default AuthenticationAPI;
